import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function createDomain(domainName: string) {
  const response = await fetchOrchidAPI(
    `/api/users/v1/client_portal/acquire/${domainName}`,
    {
      method: "POST",
    },
  );
  if (!response.ok) {
    const responseText = await response.text();
    throw new Error(getErrorDetail(responseText));
  }

  return response.json();
}
